function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 7.5 13.321 7.5 7.5 10.411 1.678 7.5 0 7.5 0 8.338 5.822 11.25 0 14.161 0 15 1.676 15 7.5 12.088 13.324 15 15 15 15 15 15 14.161 9.177 11.25 15 8.338 15 7.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 7.5 13.881 7.5 7.5 10.69 1.12 7.5 0 7.5 0 8.059 6.382 11.25 0 14.44 0 14.999 0 15 1.117 15 7.5 11.809 13.883 15 15 15 15 15 15 14.44 8.617 11.25 15 8.059 15 7.5",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.75 7.5 6.25 7.5 6.25 10 0 10 0 12.499 6.25 12.499 6.25 15 8.75 15 8.75 12.499 15 12.499 15 10 8.75 10 8.75 7.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.249 7.5 6.75 7.5 6.75 10.499 0 10.499 0 12 6.75 12 6.75 15 8.249 15 8.249 12 15 12 15 10.499 8.249 10.499 8.249 7.5",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.62,11.399c0,3.776.438,5.076,1.315,5.953.523.519.754.714,1.566,1.248.812-.534,1.044-.729,1.566-1.248.877-.877,1.315-2.177,1.315-5.953-.637.273-1.001.405-1.526.397-.47-.007-.969-.226-1.354-.397-.385.172-.884.39-1.354.397-.528.008-.891-.124-1.528-.397Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.591,13.29c.136.303.569.639.689.803-.152.164-.182.147-.162.451.264-.263.269-.291.439-.251.372.354.067,1.114-.241,1.279-.307.176-.252-.006-.712.214.211.172.456-.025.656.027.108.123-.052.347.032.558.177-.016.156-.356.196-.479.129-.452.905-.767.944-1.182.164-.073.328-.023.526.084-.099-.388-.427-.384-.515-.506-.209-.304-.394-.652-.841-.742-.339-.069-.313.02-.531-.12-.137-.101-.547-.291-.481-.136h0Z",
    style: {
      fill: "#f90"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.496,
    cy: 13.635,
    r: 0.071,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.506,14.577c.218-.256.327-.779.423-.956.223.052.22.085.494-.074-.368-.099-.395-.091-.438-.253.155-.479,1.002-.576,1.298-.394.307.177.112.215.532.5.061-.259-.237-.372-.281-.566.064-.149.346-.118.503-.288-.098-.142-.403.035-.537.059-.479.102-1.135-.405-1.537-.245-.145-.104-.174-.265-.168-.482-.313.265-.157.539-.229.67-.185.319-.421.637-.295,1.056.095.318.166.255.137.505-.029.161-.014.597.098.469h0Z",
    style: {
      fill: "#f90"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.404,
    cy: 13.653,
    r: 0.071,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.28,14.757c-.343-.045-.868.137-1.077.15-.07-.208-.037-.224-.323-.365.101.352.123.369,0,.487-.51.121-1.035-.52-1.026-.855,0-.342.136-.202.174-.693-.264.084-.212.385-.363.522-.167.025-.285-.221-.519-.261-.077.153.241.31.33.408.34.339.223,1.135.575,1.38-.018.172-.148.279-.346.387.4.119.565-.151.72-.161.382-.014.79.013,1.101-.305.237-.242.144-.267.382-.372.161-.058.543-.296.371-.322h0Z",
    style: {
      fill: "#f90"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.503,
    cy: 15.319,
    r: 0.071,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.342,16.551c.168.319.365.574.592.801.523.519.754.714,1.566,1.248.812-.534,1.044-.729,1.566-1.248.227-.227.424-.482.592-.801h-4.316Z",
    style: {
      fill: "#9cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11.25c0,3.932.456,5.288,1.369,6.201.544.54.786.744,1.631,1.299.845-.555,1.087-.759,1.631-1.299.913-.913,1.369-2.268,1.369-6.201-.664.284-1.043.422-1.59.414-.489-.008-1.009-.235-1.411-.414-.401.179-.92.406-1.411.414-.547.009-.925-.129-1.59-.414ZM19.68,11.46c.624.268.98.398,1.495.39.46-.007.948-.221,1.326-.39.377.169.866.383,1.326.39.515.008.871-.122,1.495-.39,0,3.712-.429,4.991-1.286,5.854-.512.511-.738.702-1.533,1.227-.795-.525-1.021-.717-1.533-1.227-.86-.863-1.288-2.142-1.288-5.854h0Z",
    style: {
      fill: "#fdc301"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.4619721699f8815452039b042457fe31.svg";
export { ForwardRef as ReactComponent };